
import Empty from './empty'
import Error from './error'

//-----------IMG_COMPONENT-----------------
export const IMG_EMPTY = Empty
export const IMG_ERROR = Error

